

const InfopersonReducer = (state, action) => {
    switch (action.type) {
        case "GET_INFOPERSON_START":
            return {
                ...state,
                infoperson: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_INFOPERSON_SUCCESS":
            return {
                ...state,
                infoperson: action.payload.user,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_INFOPERSON_FAILURE":
            return {
                ...state,
                infoperson: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "UPDATE_INFOPERSON_START":
            return {
                ...state,
                message: "",
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_INFOPERSON_SUCCESS":
            return {
                ...state,
                message: action.payload.message,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_INFOPERSON_FAILURE":
            return {
                ...state,
                message: "",
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "CLEAR_INFOPERSON":
            return {
                ...state,
                message: "",
                infoperson: {},
            };
        default:
            return { ...state };
    }
}

export default InfopersonReducer;